module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAANCAYAAACgu+4kAAABFUlEQVQokYXSL0jDQRQH8M/GT6wiYlCDil0wKAyzxaZBs5oFxaLZJoJgFUQwCOKSWCbOZBGxWQwrFoP/gkE3nGFvcIyNPTju7n3vvt/ve3e5Uql0jhG86xy9GMQq7lMgwzSm8IVcm8t15HGMbSykYB5PeEMN1Tajhl/chIhWgizmbjGOgWQ/hIsssTmDQnLgBB+BQRHlWI+igsNUeRizQVLQ6McSrgJ/wDUm4vIu1rM4mA+FYovtMjZxF6RjeMYW9kX9dfxhHouxzoVCReOVzvAYLjdw0FRo9gC+8ZrUXE2wZRyF6mlqsVlCDrcxOsVau2QeP2G7W6xgrzWZYRJ9+OxCMIf+dgQvuNSov9NX7tF4vp1W8B/l6z+IP7Fc9gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/apps/37.png
// module id = ydj4
// module chunks = 0